import * as React from "react";
import { Sun, Moon } from "lucide-react";
import { Button } from "../Button";
import * as s from "./DarkModeToggle.css";

export type DarkModeTogglePlacement = "fixed" | "header";

export interface DarkModeToggleProps {
  /** Whether dark mode is currently active. */
  isDark: boolean;
  /** Callback invoked when the toggle is clicked. */
  onToggle: () => void;
  /** Controls positioning. "fixed" pins to top-right; "header" renders inline. */
  placement?: DarkModeTogglePlacement;
}

/**
 * A ghost icon button that switches between sun (light) and moon (dark) icons.
 * Presentational — wire up `isDark` and `onToggle` from your theme hook.
 */
export function DarkModeToggle({
  isDark,
  onToggle,
  placement = "fixed",
}: DarkModeToggleProps) {
  return (
    <Button
      type="button"
      variant="ghost"
      color="neutral"
      size="sm"
      iconOnly
      className={s.wrapper[placement]}
      onClick={onToggle}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
    >
      {isDark ? (
        <Moon strokeWidth={1.75} aria-hidden />
      ) : (
        <Sun strokeWidth={1.75} aria-hidden />
      )}
    </Button>
  );
}
